import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

function SuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const rawMessage = location.state?.message || "Your form has been submitted successfully!";

  const stripHtml = (html) => {
    if (!html || typeof html !== 'string') {
      return "Your form has been submitted successfully!";
    }
    // Parse and strip HTML properly
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const cleanMessage = stripHtml(rawMessage);

  return (
    <div className="min-h-screen bg-muted flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-card rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <CheckCircleIcon className="h-16 w-16 text-green-500" />
        </div>
        {/* <h1 className="text-3xl font-bold text-foreground mb-4">Success!</h1> */}
        <p className="text-muted-foreground text-lg mb-8 whitespace-pre-line">
          {/* {cleanMessage} */}
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors duration-200"
          >
            Go to Home
          </button>
          <button
            onClick={() => navigate(-1)}
            className="bg-muted hover:bg-muted text-foreground px-6 py-2 rounded-lg transition-colors duration-200"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
